import React, {Component}  from "react";
import PropTypes from 'prop-types';
import SortableChaptersContainer from '../../containers/AdminPanel/SortableChaptersContainer';
import SortableChapterContainer from './SortableChapterContainer';
import ModalDelete from './ModalDelete';
import ModalDeleteCourse from './ModalDeleteCourse';
import ModalAddEditChapter from './ModalAddEditChapter';
import ModalAddAnotherSubject from "./ModalAddAnotherSubject";
import AddCourseModal from '../Common/AddCourseModal';
import ModalDeleteSubject from './ModalDeleteSubject';
import ModalDeleteChapter from './ModalDeleteChapter';
import {withRouter, Link} from 'react-router-dom';
import ChapterTestModal from './ChapterTestModal';


const tabsArr = [
    ['#mcat_tab', 'MCAT'],
    ['#lsat_tab', 'LSAT'],
    ['#gmat_tab', 'GMAT']
];
/* global $ */

class CourseAdmin extends Component {
    state = {
        newTabModelIsOpen: false,
        newTabName: '',
        editChapterModal: false,
        courseId: 0,
        subjectId: 0,
        activeCourse: null,
        chapter: {
            number: '',
            name: '',
            status: true,
            description: '',
        },
        subjects: {
            subjectName: '',
            description: '',
            img: ''
        },
        showModalDeleteCourse: false,
        courseToDelete: {},
        showDeleteSubjectModal: false,
        deleteSubject: {},
        showDeleteChapterModal: false,
        deleteChapter: {},
        addTest: {
            status: true,
            subjectChapterId: '',
            subjectId: '',
            courseId: '',
            feedbackPrompt: '',
            number: 0
        }
    };

    handleNewTabOpenState = () => {
        this.setState({
            newTabModelIsOpen: !this.state.newTabModelIsOpen,
        })
    };

    addTest = (courseId, subjectId, chapterId, number) => {
        this.setState({addTest: {
            ...this.state.addTest,
            courseId: courseId,
            subjectId: subjectId,
            subjectChapterId: chapterId,
            number: number
        }}, () => {
            $(`#chapter-test-modal-${subjectId}`).modal('toggle');
        });
    }

    addNewCourse = (name, slug) => {
        this.props.addNewCourse({name: name, strategy: "manual_strategy_active", slug: slug, owner: this.props.user.userId, published: false, officialTest: {
            name: "",
            minScore: "",
            maxScore: "",
            sections: [
            {
                name: "",
                minScore: "",
                maxScore: ""
            }
            ]
        }}, this.props.user.id);
                this.setState({
                    newTabName: name,
                });
        tabsArr.push([`#${name.toLowerCase()}_tab`, `${name}`])
    };

    // Renders
    renderHeaderPage = () => (
        <div className="bg-light lter b-b wrapper-md">
            <div className="row">
                <div className="col-sm12 col-xs-12">
                    <h1 className="m-n font-thin h3 text-black">
                        Course Manager
                    </h1>
                    <small className="text-muted">
                        Manage your all subjects
                    </small>
                </div>
            </div>
        </div>
    );

    deleteCourseConfirmation = (course) => {
        this.setState({courseToDelete: course, showModalDeleteCourse: true})
    }

    deleteChapterConfirmation = (chapter) => {
        this.setState({deleteChapter: chapter, showModalDeleteChapter: true});
    }

    renderNavigationLinks = () => (
        <ul className="nav nav-tabs bg-white">
            {this.renderLink('', 'course-admin', 'Courses', 'All Courses')}
            {this.props.activeCourse ?
                this.props.activeCourse.id ?
                    <span>
                        {this.renderLink('active', 'strategy', 'Strategy', 'Setup Strategy')}
                        {this.renderLink('', 'people', 'People', 'Access Manager')}
                        {this.renderLink('', 'settings-admin', 'Settings', 'Updates')}
                    </span>
            : null
            : null }
        </ul>
    );
    renderLink = (className, link, title ,subTitle) => (
        <li
            className={className}
        >
            <Link to={link}>
                {title}
                <span>
                    {subTitle}
                </span>
            </Link>
        </li>
    );

    renderNavigationTabs = () => (
        <ul className="nav nav-tabs">

            {this.props.courses.length > 0 &&
                this.renderTabNew()}
            {/*{this.renderTab('active', '#mcat_tab', 'MCAT')}*/}
            {/*{this.renderTab('', '#lsat_tab', 'LSAT')}*/}
            {/*{this.renderTab('', '#gmat_tab', 'GMAT')}*/}
            {/*{*/}
            {/*this.state.newTabName !== '' &&*/}
            {/*this.renderTab('', '#gfet_tab', `${this.state.newTabName}`)*/}
            {/*}*/}
            {/*/////////////////////*/}
            <div>
                <a className="btn btn-orange btn-rounded"
                    onClick={this.handleNewTabOpenState}
                >
                    {this.props.courses.length === 0 &&
                    "Add Course "}
                        <i className="zmdi zmdi-plus-circle"/>

                </a>
            </div>
        </ul>
    );

    renderTabNew = () => {
        return (
            this.props.courses.map((item, index) => {

                if(this.props.activeCourse === null && index === 0){
                    //this.setState({activeCourse: item});
                    this.props.setActiveCourse(item, this.props.user.user.Profile.id, this.props.user.id);
                }
                if(item) {
                    return (
                        <li
                            key={index}
                            className={this.props.match.params.courseId === item.id ? 'active' : ''}
                        >
                            <Link
                                to={`/course-admin/${item.id}`}
                            >
                                {item.name}
                                <span className={"zmdi zmdi-close"} onClick={(e) => {
                                    e.preventDefault();
                                    this.deleteCourseConfirmation(item);
                                }}/>
                            </Link>
                        </li>
                    )
                }
            })
        )
    };

    renderTabContent = (subjects) => {


        return (
            <div>
                {this.props.activeCourse.CourseSubject && this.renderTabPaneBody(this.props.activeCourse.CourseSubject)}
            </div>
        )

    };

    renderTabPaneBody = (subjects) => (
        <div className="panel customPanel no-bg flat">
            <div className="panel-body">
                <div className="sm-bottom30">
                    <div className="row">
                        <div className="col-sm-3">
                            <label>
                                <input
                                    type="radio"
                                    name="Strategy_Type"
                                    onChange={(e) => this.handleChangeCheckStrategy(e)}
                                    value="Automated"
                                    defaultChecked={true}
                                />
                                Automated Strategy
                            </label>
                        </div>
                        <div className="col-sm-3">
                            <label>
                                <input
                                    type="radio"
                                    name="Strategy_Type"
                                    onChange={(e) => this.handleChangeCheckStrategy(e)}
                                    value="Manual"
                                />
                                Manual Strategy
                            </label>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="panel customPanel">
                        <div className="panel-body">
                            <div className="row">
                                <div className="col-sm-5">
                                    <div className="BtnWithTextBox">
                                        <label>
                                            Diagnostic Test Name:
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                        />
                                        <a
                                            href="#AddStrategyModal2"
                                            data-toggle="modal"
                                            className="btn btn-info"
                                        >
                                            <i className="zmdi zmdi-plus-circle"/>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderStrategyConditions()}
                {
                    subjects &&
                    this.renderCourses(subjects)
                }
            </div>
        </div>
    );


    renderTabContentCourses = (subjects) => {
        return (
            <div className="tab-content no-bg ">
                <div
                    className="tab-pane active"
                    id="course_1"
                >
                    {
                        subjects &&
                        this.renderCourses(subjects)
                    }
                    <br />
                    <div className="padder-md">
                    <a
                        href="#AddAnotherSubject"
                        data-toggle="modal"
                        className="btn btn-success"
                    >
                        <i className="zmdi zmdi-plus-circle"/>
                        Add Subject
                    </a>
                    &nbsp; 
                    <a
                        href="#"
                        onClick={e => {
                            e.preventDefault();
                            let data = {
                                name: 'Review and Tests',
                                slug: 'review-and-tests',
                                description: '',
                                img: '',
                                type: 'review'
                            }
                            
                            this.props.addNewSubject(data, this.props.activeCourse.id, this.props.user.userId, this.props.user.id, this.props.socket, this.props.user.user.Profile.id)
                        }}
                        className="btn btn-primary"
                    >
                        <i className="zmdi zmdi-plus-circle"/>
                        Add Review Subject
                    </a>
                    </div>
                    <br /><br /><br />
                </div>
                <div
                    className="tab-pane"
                    id="course_2"
                >
                    <div className="panel customPanel">
                        <div className="panel-body">
                            course_2
                        </div>
                    </div>
                </div>
                <div
                    className="tab-pane"
                    id="course_3"
                >
                    <div className="panel customPanel">
                        <div className="panel-body">
                            course_3
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderChaptersNew = (chapters) => {

        return (
            <SortableChapterContainer
                chapters={chapters}
                showModalDelete={() => {return null}}
                deleteChapterConfirmation={(item) => this.deleteChapterConfirmation(item)}
                editChapter={(item) => {
                    this.setState({
                        editChapterModal: true,
                        chapter: item
                    })
                }}
                user={this.props.user}
                reorderChapters={this.reorderChapters}
                reorderChapterParts={this.reorderChapterParts}
                updateChapterStatus={this.updateChapterStatus}
                updateChapterPartStatus={this.updateChapterPartStatus}
                history={this.props.history}
                addTest={this.addTest}
            />
        )
    }

    reorderChapters = (chapters, token) => {
        this.props.reorderChapters(chapters, token);
    }

    reorderChapterParts = (chapterParts, token) => {
        this.props.reorderChapterParts(chapterParts, token);
    }

    updateChapterStatus = (id, status) => {
        this.props.updateChapterStatus(id, status, this.props.user.id);
    }

    updateChapterPartStatus = (id, status) => {
        this.props.updateChapterPartStatus(id, status, this.props.user.id);
    }

    renderCourses = (subjects) => {

        if(subjects !== null) {

            return (
                subjects.map((item, index) => (
                    <div
                        className="panel customPanel no-bg m20"
                        key={index}
                    >
                        <div className="panel-heading bg-dd">
                            <div className="panel-control sp-top10">
                                <a
                                    href={"#subject_" + index}
                                    data-toggle="collapse"
                                    className="font-24"
                                    onClick={e => {
                                        this.props.history.push(`/course-admin/${this.props.match.params.courseId}/${item.id}`)
                                    }}
                                >
                                    <i className="zmdi zmdi-chevron-down"/>
                                </a>
                            </div>
                            <h3 className="panel-title subject-title">
                                <a
                                    href={"#subject_" + index}
                                    data-toggle="collapse"
                                    onClick={e => {
                                        this.props.history.push(`/course-admin/${this.props.match.params.courseId}/${item.id}`)
                                    }}
                                >
                                <span className="font-20 font-400">
                                    {item.name}
                                </span>
                                </a>
                            </h3>
                        </div>

                        <div
                            className={`panel-body subject-panel bg-grey collapse ${index === 0 && "in"}`}
                            id={"subject_" + index}
                            style={{paddingLeft: "20px !important"}}
                            
                        >
                            {item.type !== 'review' &&
                            <div className="row subject-info-row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>Expected duration (in days)</label>
                                        <input
                                            className="form-control"
                                               type="number"
                                               placeholder="Expected duration (in days)"
                                                value={item.duration || ''}
                                                onChange={(e) => {
                                                    item.duration = e.target.value;
                                                    this.props.fakeUpdateSubject(item);
                                                }}
                                               />
                                    </div>
                                </div>
                                <div className="col-md-3">

                                    <div className="form-group">
                                        <label> <br /></label><br />
                                        <button
                                            className="btn btn-success"
                                            onClick={(e) => {
                                                this.props.updateSubject(item, this.props.user.id);
                                            }}
                                        >Update</button>
                                    </div>

                                </div>
                                <div className="col-md-6">
                                    <Link className="subject-link" to={`/video/${item.courseId}/${item.id}`}>https://portal.99point9.ca/video/{item.courseId}/{item.id}</Link>
                                </div>
                            </div>
                            }
                            {item.CourseChapter &&
                                this.renderChaptersNew(item.CourseChapter)}
                                <div className="padder-md">
                                    <a
                                        href="#EditChapterModal"
                                        data-toggle="modal"
                                        className="btn btn-primary"
                                        onClick={() =>
                                            this.setState({
                                                editChapterModal: false,
                                                subjectId: item.id,
                                                courseId: item.courseId
                                            })
                                        }
                                    >
                                        <i className="zmdi zmdi-plus-circle"/> &nbsp;
                                        Add Chapter
                                    </a> &nbsp;


                                    <button

                                        className="btn btn-danger"
                                        onClick={() =>
                                            this.setState({
                                                showDeleteSubjectModal: true,
                                                deleteSubject: item
                                            })
                                        }
                                    >
                                        <i className="zmdi zmdi-close"/> &nbsp;
                                        Delete Subject
                                    </button> &nbsp;

                                </div>
                        </div>
                        {this.props.activeCourse &&
                            item.CourseChapter ?
                            <ChapterTestModal
                                courseId={item.courseId}
                                chapterTestTemplates={this.props.activeCourse.ChapterTestTemplate || []}
                                modalId={`chapter-test-modal-${item.id}`}
                                createChapterTestFromTemplate={this.createChapterTestFromTemplate}
                                subjectId={item.id}
                                number={item.CourseChapter.length + 1}
                            />
                            : null
                        }
                    </div>
                ))
            )
        }else{
            return (
                <h1>No Subjects</h1>
            )
        }
    }
    
    createChapterTestFromTemplate = (test, subjectId, number) => {
        let chapterTest = JSON.parse(JSON.stringify(test));
        delete chapterTest.id;
        chapterTest.courseSubjectId = subjectId;
        chapterTest.type = "test";
        chapterTest.status = true;
        chapterTest.number = number;

        // console.log("THAT", this.state.addTest);
        // console.log("TPCT", chapterTest);

        let addTest = {
            ...chapterTest,
            ...this.state.addTest,
            status: false
        }

        delete chapterTest.id;
        
        this.props.saveTest(addTest, this.props.user.id);
    }

    redirect = (location) => {
        this.props.history.push(location);
    }

    renderChapters = (chapters) => (
        chapters.map((item, index) => {
            let parts = item.ChapterVideo.sort(function(a,b) {
                return (a.number < b.number) ? 1 : ((b.number < a.number) ? -1 : 0)
            } );

            if (item.name) {
                return (
                    <div
                        key={`chapter_${index}`}
                        className="panel customPanel"
                    >
                        <div className="panel-heading bg-gray">
                            <div className="panel-control">

                                <div className="btn-group">
                                    <button
                                        data-toggle="dropdown"
                                        className="dropdown-toggle btn btn-info btn-no-bg-i"
                                        aria-expanded="false"
                                    >
                                        <i className="zmdi zmdi-chevron-down padding-rgt"/>
                                        Options
                                    </button>
                                    <ul className="dropdown-menu dropdown-menu-right">
                                        <li>
                                            <a href={'edit-chapter-part?chapterId=' + item.id + "&number=" + index}>
                                                <i className="zmdi zmdi-plus-circle"/>
                                                &nbsp; Add Chapter Part
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href="#EditChapterModal"
                                                data-toggle="modal"
                                                onClick={() =>
                                                    this.setState({
                                                        editChapterModal: true,
                                                        chapter: item
                                                    })
                                                }
                                            >
                                                <i className="zmdi zmdi-edit"/>
                                                &nbsp; Edit Chapter Info
                                            </a>
                                        </li>
                                        <li>
                                            <a
                                                href={""}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    this.deleteChapterConfirmation(item);
                                                }}
                                            >
                                                <i className="zmdi zmdi-delete"/>
                                                &nbsp;Delete This Chapter
                                            </a>
                                        </li>
                                        <li>
                                            <a href="#">
                                                <i className="zmdi zmdi-upload"/>
                                                &nbsp;Upload PDF
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <h3 className="panel-title">
                            <span className="font-18 font-400 text-uppercase">
                                {item.name} {item.number}
                            </span>
                            </h3>
                        </div>
                        <SortableChaptersContainer
                            parts={parts}
                            redirect={this.redirect}
                            number={index}
                            updateChapterStatus={this.updateChapterStatus}
                            updateChapterPartStatus={this.updateChapterPartStatus}
                            deleteChapterConfirmation={(item) => this.deleteChapterConfirmation(item)}
                            history={this.props.history}
                            pressDelay={100}
                        />
                    </div>
                )
            }
        })
    );

    renderNavTabs = () => (
        this.props.activeCourse ?
        <ul className="nav nav-tabs bg-white">
            {this.renderNavItem('active', '/course-admin', 'Courses', 'All Courses')}
            {this.renderNavItem('', '/strategy', 'Onboarding', 'Setup Onboarding')}
            {this.renderNavItem('', '/people', 'People', 'Access Manager')}
            {this.renderNavItem('', '/settings-admin', 'Settings', 'Updates')}
        </ul>
        : 
        <ul className="nav nav-tabs bg-white">
            {this.renderNavItem('active', '/course-admin', 'Courses', 'All Courses')}
        </ul>
    );

    renderNavItem = (className, link, title, name) => (
        <li className={className}>
            <Link to={link}>
                {title}
                <span>
                    {name}
                </span>
            </Link>
        </li>
    );

    renderNavPlusButton = (className, link, icon) => (
        <li className={className}>
            <a
                href={link}
                style={{paddingRight: "10px"}}
            >
                <div className="font-24 text-orange">
                    <i className={"zmdi zmdi-"+icon}/>
                </div>
            </a>
        </li>
    );

    //Actions
    resetChapterState = () => {
        this.setState({
            chapter: {
                number: '',
                name: '',
                description: '',
            }
        })
    };

    resetSubjectState = () => {
        this.setState({
            subjects: {
                subjectName: '',
                description: '',
                img: ''
            }
        })
    };

    //Lifecycle
    componentWillMount() {
        this.props.onLoadCourses(this.props.user.userId, this.props.user.user.Profile.CourseUser);
        this.props.onLoadSubjects();
        if(this.props.match.params.courseId){
            this.props.getSingleCourse(this.props.match.params.courseId, this.props.user.id);
        }else if(this.props.courses && !this.props.match.params.courseId && this.props.courses[0]){
            this.props.history.push(`/course-admin/${this.props.courses[0].id}`);
        }else if(this.props.courses && this.state.activeCourse != this.props.activeCourse){
            let course = this.props.activeCourse;
            
            if(course){
                this.setState({activeCourse: course});
            }
        }
    }

    componentWillUpdate(props){
        if(props.activeCourse){
            if(props.match.params.courseId !== this.props.match.params.courseId){
                props.getSingleCourse(props.match.params.courseId, props.user.id);
            }else if(props.activeCourse.id === props.match.params.courseId && !props.match.params.subjectId){
                if(props.activeCourse.CourseSubject){
                    if(props.activeCourse.CourseSubject[0]){
                        props.history.push(`/course-admin/${props.activeCourse.id}/${props.activeCourse.CourseSubject[0].id}`)
                    }
                }
            }else if(props.activeCourse.id && props.match.params.subjectId && props.activeCourse.CourseSubject.filter(s => s.id === props.match.params.subjectId)[0]){
                if(props.activeCourse.CourseSubject.filter(s => s.id === props.match.params.subjectId)[0].loading){
                    props.getSingleSubject(props.match.params.subjectId, props.user.id);
                }
            }else if(props.match.params.subjectId !== this.props.match.params.subjectId){
                props.getSingleSubject(props.match.params.subjectId, props.user.id);
            }else if(props.courses && !props.match.params.courseId && this.props.courses[0]){
                props.history.push(`/course-admin/${props.courses[0].id}`);
            }else if(props.courses && this.state.activeCourse != props.activeCourse){
                let course = this.props.activeCourse;
                
                if(course){
                    this.setState({activeCourse: course});
                }
            }
        }
    }

    render() {
        const {
            courses,
            activeCourse,
            subjects,
            editChapterInfo,
            addNewChapter,
            addNewSubject
        } = this.props;

        return (
            <div
                className="content-wrapper"
                id="content-container"
            >
                {this.renderHeaderPage()}
                <section className="content no-padding">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="nav-tabs-custom no-bg">
                                {this.renderNavTabs()}
                                <div className="tab-content no-bg no-padding">
                                    <div className="nav-tabs-custom no-bg inner-tabs">
                                        {this.renderNavigationTabs()}
                                        <div className="tab-content no-bg no-padding">

                                            {activeCourse &&
                                                activeCourse.CourseSubject ? 
                                                    this.renderTabContentCourses(activeCourse.CourseSubject)
                                                : null
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {
                    this.state.newTabModelIsOpen &&
                    <AddCourseModal
                        onCloseModal={this.handleNewTabOpenState}
                        addNewCourse={this.addNewCourse}
                        user={this.props.user}
                    />
                }
                {
                    this.props &&
                    <ModalDelete
                        hideModalDelete={this.props.hideModalDelete}
                        showModalDeletePart={this.props.showModalDeletePart}
                        removeChapterConfirmation={(chapter) => this.props.removeChapterConfirmation(chapter, this.props.user.id)}
                        partId={this.props.partId}
                    />

                }

                {this.props &&
                <ModalDeleteCourse
                    hideModalDelete={() => {
                        this.setState({showModalDeleteCourse: false});
                    }}
                    showModalDeleteCourse={this.state.showModalDeleteCourse}
                    removeCourseConfirmation={(id) => {
                        if(this.props.activeCourse.id === id){
                            let activeCourse = null;
                            if(this.props.courses.length > 1) {
                                let coursesWithoutActive = this.props.courses.filter(course => {
                                    if(course){
                                        return course.id !== id
                                    }
                                });
                                if (coursesWithoutActive.length > 0) {
                                    activeCourse = coursesWithoutActive[0];
                                }
                            }
                            this.setState({activeCourse});
                        }
                        this.props.removeCourseConfirmation(id, this.props.user.id);
                    }}
                    courseId={this.state.courseToDelete.id || 0}
                    courseName={this.state.courseToDelete.name || ''}

                />}

                {this.props &&
                <ModalDeleteSubject
                    hideModalDelete={() => {
                        this.setState({showDeleteSubjectModal: false});
                    }}
                    showDeleteSubjectModal={this.state.showDeleteSubjectModal}
                    removeSubjectConfirmation={(id) => {
                        this.props.removeSubjectConfirmation(id, this.props.user.id);
                    }}
                    subjectId={this.state.deleteSubject.id || 0}
                    subjectName={this.state.deleteSubject.name || ''}

                />}


                {this.props &&
                <ModalDeleteChapter
                    hideModalDelete={() => {
                        this.setState({showModalDeleteChapter: false});
                    }}
                    showModalDeleteChapter={this.state.showModalDeleteChapter}
                    removeChapterConfirmation={(id) => {
                        this.props.deleteOneChapter(id, this.props.user.id);
                    }}
                    chapterId={this.state.deleteChapter.id || 0}

                />}
                <ModalAddEditChapter
                    chapter={this.state.chapter}
                    courseId={this.state.courseId}
                    subjectId={this.state.subjectId}
                    editChapterModal={this.state.editChapterModal}
                    editChapterInfo={(data, files) => editChapterInfo(data, this.state.courseId, this.state.subjectId, files, this.props.user.userId, this.props.user.user.Profile.CourseUser, this.props.user.id)}
                    addNewChapter={(data, files, subjectId) => addNewChapter(data, this.state.courseId, this.state.subjectId, files, this.props.user.userId, this.props.user.user.Profile.CourseUser, this.props.user.id)}
                    resetChapterState={() => {
                        this.resetChapterState();
                        this.setState({editChapterModal: false});
                    }}
                    user={this.props.user}
                    open={this.state.editChapterModal}
                    deleteChapterFile={this.props.deleteChapterFile}
                    closeModal={() => this.setState({editChapterModal: false})}
                />
                <ModalAddAnotherSubject
                    subjects={subjects}
                    course={this.state.activeCourse}
                    addNewSubject={(data) => addNewSubject(data, this.props.match.params.courseId, this.props.user.userId, this.props.user.id, this.props.socket, this.props.user.user.Profile.id)}
                    resetSubjectState={this.resetSubjectState}
                    
                />
                
                
            </div>
        )
    }
}

CourseAdmin.propTypes = {
    onLoadCourses: PropTypes.func.isRequired,
    subjects: PropTypes.array.isRequired,
    editChapterModal: PropTypes.func,
    editChapterInfo: PropTypes.func,
    addNewChapter: PropTypes.func,
    deleteOneChapter: PropTypes.func,
    hideModalDelete: PropTypes.func,
    showModalDeletePart: PropTypes.bool,
    removeChapterConfirmation: PropTypes.func,
    partId: PropTypes.any
};

export default withRouter(CourseAdmin);


// WEBPACK FOOTER //
// ./src/components/AdminPanel/CourseAdmin.js